import { makeAutoObservable, toJS } from 'mobx'

import { Count } from 'widgets/level-count/level-count'

import { RangeDate } from 'entities/ticket/models/find-ticket/models.ts'

import beketListTicketsStore from '../ticket/beket-list-tickets/beket-list-tickets-store'

import {
  BeketDifficultRoute,
  BeketFindTicketForm,
  BeketSelectedCountry,
  BeketSetDirection,
} from './model'

const DefaultCityFromBeket: BeketSelectedCountry = {
  id: 1,
  cityName: 'Бишкек',
  countryName: 'Кыргызстан',
}

const initialState: BeketFindTicketForm = {
  directions: [
    {
      from: DefaultCityFromBeket,
    },
  ],
  adult: 1,
  child: 0,
}

class FindTicketFormStore {
  formFindTicket: BeketFindTicketForm = initialState
  copyFormFindTicket: BeketFindTicketForm | null = null

  constructor() {
    makeAutoObservable(this)
  }

  onSelectDirection(direction: BeketDifficultRoute) {
    this.formFindTicket.directions[0] = direction
  }

  onSelectDirectionFrom({ depp, index = 0, isCopy }: BeketSetDirection) {
    if (isCopy && this.copyFormFindTicket) {
      this.copyFormFindTicket.directions[index].from = depp
    } else {
      this.formFindTicket.directions[0].from = depp
    }
  }

  onSelectDirectionTo({ depp, index = 0, isCopy }: BeketSetDirection) {
    if (isCopy && this.copyFormFindTicket) {
      this.copyFormFindTicket.directions[0].to = depp
    } else {
      this.formFindTicket.directions[index].to = depp
    }
  }

  onSwitchDirection(index: number) {
    const directions = toJS(this.formFindTicket.directions[index])
    const from = { ...directions.from }

    directions.from = directions.to

    if (from?.id) {
      directions.to = {
        ...from,
        id: from?.id,
        cityName: from.cityName || '',
        countryName: from.countryName || '',
      }
    }

    this.formFindTicket.directions[index] = directions
  }

  getCountPassengers() {
    return {
      adult: this.formFindTicket.adult,
      child: this.formFindTicket.child,
    }
  }

  getLengthOfPassengers() {
    return (this.formFindTicket.adult || 0) + (this.formFindTicket.child || 0)
  }

  getFormFindTicketDirections() {
    return toJS(this.formFindTicket?.directions)
  }

  onSetRangeDate({ rangeData, indexDirect = 0, isCopy }: RangeDate) {
    if (isCopy && this.copyFormFindTicket !== null) {
      this.copyFormFindTicket.directions[indexDirect] = {
        ...this.copyFormFindTicket.directions[indexDirect],
        date: rangeData?.startDate,
        back_date: rangeData?.endDate,
      }

      return
    }

    this.formFindTicket.directions[indexDirect] = {
      ...this.formFindTicket.directions[indexDirect],
      date: rangeData?.startDate,
    }
  }

  getFormFindTicketDirectionsCopy() {
    return toJS(this.copyFormFindTicket?.directions)
  }

  onSwitchDirectionCopy(index: number) {
    if (!this.copyFormFindTicket?.directions) return

    const directions = toJS(this.copyFormFindTicket.directions[index])
    const from = { ...directions.from }

    directions.from = directions.to

    if (!from?.id) return

    directions.to = {
      ...from,
      cityName: from.cityName || '',
      countryName: from.countryName || '',
      id: from.id,
    }

    this.copyFormFindTicket.directions[index] = directions
  }

  setCopyForSearch() {
    if (this.copyFormFindTicket) {
      this.formFindTicket = toJS(this.copyFormFindTicket)
      beketListTicketsStore.resetListOfTicket()
    }
  }

  resetDirectionCopy() {
    this.copyFormFindTicket = null
  }

  onSetDataCopy() {
    this.copyFormFindTicket = toJS(this.formFindTicket)
  }

  onSetCount(data?: Count, isCopy?: boolean) {
    if (isCopy && this.copyFormFindTicket !== null) {
      this.copyFormFindTicket = {
        ...this.copyFormFindTicket,
        ...data,
      }

      return
    }

    this.formFindTicket = {
      ...this.formFindTicket,
      ...data,
    }
  }
  getCountOfPassengers(): number {
    const passengers = this.formFindTicket

    return (passengers?.adult || 0) + (passengers?.child || 0)
  }

  setFormFindTicket(searchData: BeketFindTicketForm) {
    this.formFindTicket = searchData
  }
}

export default new FindTicketFormStore()
